import type { clientTypes } from '@bedc/client/types';

import { Id } from '../../../constants/constants/brand';
import { profiles } from '../config';

/**
 * Resolve a brand, using the default for an absent or empty selection.
 *
 * @param value The configured or runtime brand selection.
 * @returns A supported brand ID.
 * @throws When the selection does not match a supported brand.
 */
export function resolveBrandId(value?: string): clientTypes.brand.Id {
	if (value === undefined || value === '') return 'bedc';
	const id = Id.find((id) => id === value);
	if (id) return id;
	throw new Error(`Unknown brand "${value}". Expected: ${Id.join(', ')}`);
}

/**
 * Get the public asset directory for the selected brand.
 *
 * @param id The selected brand ID.
 * @returns The asset directory without a trailing slash.
 */
export function getBrandAssetPath(id?: clientTypes.brand.Id): string {
	return `/brands/${resolveBrandId(id)}`;
}

/**
 * Get the complete profile for the selected brand.
 *
 * @param id The selected brand ID, or the default when omitted.
 * @returns The application profile.
 */
export function getBrandProfile(id?: clientTypes.brand.Id): clientTypes.brand.Profile {
	return profiles[resolveBrandId(id)];
}
